const config = {
    format_tags: 'p;h2;h3;h4;h5;h6;pre'
};

export default config;
